// Libs
import React from "react";
import PropTypes from "prop-types";

export default function PageBody({ menu, main }) {
  return (
    <>
      <div slot="page-body-menu">{menu}</div>
      <div slot="page-body-main">{main}</div>
    </>
  );
}

PageBody.propTypes = {
  menu: PropTypes.node,
  main: PropTypes.node
};
